export default class HiddenFields implements IDigitalIdentityHubModule {
  public name = "HiddenFields";

  public init(): void { /* No functionality */ }

  public ready(): void {
    janrain.events.onCaptureScreenShow.addHandler(function(result) {
      janrain.settings.capture.prevScreenName = janrain.settings.capture.currentScreenName;
      janrain.settings.capture.currentScreenName = result.screen;
    });

    janrain.events.onCaptureRenderStart.addHandler(function(result) {
      janrain.settings.capture.flowVersionNumber = result.version;
    });

    janrain.events.onCaptureRenderComplete.addHandler(function(result) {
      // list of screens with hidden fields
      const screens = ["registrationCompletion", "traditionalRegistration", "shortRegistration", "socialRegistration", "legalAcceptances", "createPassword", "consentAcquisitionRegistration"];

      screens.forEach(screen => {
        if (result.screen === screen) {
          const referralField = document.getElementById(`capture_${screen}_referral`);
          const emailVerifiedField = document.getElementById(`capture_${screen}_emailVerifiedHidden`);
          const preregEmailHiddenField = document.getElementById(`capture_${screen}_preregEmailAddressHidden`);
          const userStatusHiddenField = document.getElementById(`capture_${screen}_userStatusHidden`);

          // fills referral field on all registration screens
          // contains a fix for the case where a ? at the end of the referral URL caused registration to fail/not submit
          if (referralField instanceof HTMLInputElement) {
            const originParam = window.DigitalIdentityHub.utilities.getParameterByName("origin");
            const tempHref = originParam ? originParam : window.top.location.href;
            const tempReferral = tempHref.split("?");
            referralField.value = tempReferral.length > 1 && tempReferral[1] !== "" ? tempReferral[0] + "?" + tempReferral[1] : tempReferral[0];
          }
          // sets emailVerified on all registration screens with default value
          // applicable only for non mandatory email verification
          if (emailVerifiedField instanceof HTMLInputElement) {
            emailVerifiedField.value = "1900-01-01T00:00:00Z";
            if (result.screen === "createPassword" || result.screen === "registrationCompletion") {
              emailVerifiedField.value = new Date().toISOString();
            }
          }
          // sets prereg_email to "ok" when finishing preregistration
          if (preregEmailHiddenField instanceof HTMLInputElement) {
            preregEmailHiddenField.value = "ok";
          }
          // sets userStatus to active when finishing preregistration
          if (userStatusHiddenField instanceof HTMLInputElement) {
            userStatusHiddenField.value = "active";
          }
        }
      });

      if (result.screen === "consentAcquisitionRegistration") {
        const registrationServiceHidden = window.DigitalIdentityHub.utilities.getCaptureField("consentAcquisitionRegistration", "registrationServiceHidden") as HTMLInputElement;
        registrationServiceHidden.value = "Janrain Widget - Consent Form";
      }

      if (result.screen === "socialRegistration") {
        const emailSocial = document.getElementById("capture_socialRegistration_email");
        // sets emailVerified on socialRegistration based whether social provider email is shared or not
        // applicable only for non mandatory email verification
        const emailHidden = document.getElementById("capture_socialRegistration_emailVerifiedHidden") as HTMLInputElement;
        if (emailHidden) {
          emailHidden.value = emailSocial instanceof HTMLInputElement && emailSocial.value === "" ? "1900-01-01T00:00:00Z" : new Date().toISOString();
        }
      }

      // sets/updates consent times
      for (const fieldId of [
        "capture_editProfile_mciClinicalInfoTime",
        "capture_editProfile_mciCorporateInfoTime",
        "capture_editProfile_mciProductInfoTime",
        "capture_editProfile_brandedConsentTimeHidden",
        "capture_traditionalRegistration_brandedConsentTimeHidden",
        "capture_socialRegistration_brandedConsentTimeHidden",
        "capture_shortRegistration_brandedConsentTimeHidden"
      ]) {
        try {
          (document.getElementById(fieldId) as HTMLInputElement).value = new Date().toISOString();
        } catch (ex) { /* No functionality */ }
      }
    });
  }
}
